import React, { useState } from "react";

import { returnMoreItems } from "../../../../services/api";
import { Select } from "../../../../../ui-kit/components/Select";
import { Typography } from "../../../../../ui-kit/components/Typography/Typography";

export const UnregisteredItem = ({
  unregistered_items,
  customer_return,
  setStateOfCustomerReturn,
}) => {
  const [isOpen, setOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState(
    unregistered_items.map((item) => ({
      ...item,
      addedQuantity: item.quantity === 1 ? i : null,
      selected: false,
    }))
  );

  function updateItem(i, data) {
    setSelectedItems((old) => {
      const arr = [...old];
      arr[i] = { ...arr[i], ...data };
      return arr;
    });
  }

  function quantityOptions(max) {
    const options = [];
    for (let i = 1; i <= max; i++) options.push({ label: i, value: i });
    return options;
  }

  function cancelAddingMoreItems() {
    setOpen((prev) => {
      !prev.isOpen;
    });
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const selected = selectedItems
      .filter((item) => item.selected)
      .map((item) => ({
        sku: item.sku,
        quantity: item.addedQuantity,
      }));

    const payload = {
      customer_return: {
        items: selected,
      },
    };

    try {
      const response = await returnMoreItems(customer_return.id, payload);

      if (response.ok) {
        const responseJson = await response.json();
        const items = responseJson.customer_return.items;

        setSelectedItems((prevItems) => {
          const updatedItems = prevItems.filter((item) => {
            const updatedItem = items.find(
              (newItem) =>
                newItem.sku === item.sku && item.quantity === newItem.quantity
            );
            return !updatedItem; // Keep only items that haven't been updated
          });

          // Check if there are any unselected items left
          if (updatedItems.length === 0) {
            setOpen(false);
          }

          return updatedItems;
        });

        setStateOfCustomerReturn(responseJson.customer_return);
      } else {
        console.error(
          "Failed to submit return items. Status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  return (
    <>
      {selectedItems.length > 0 && (
        <div className="flex justify-center mt-4">
          <button
            className="justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 flex items-center gap-2"
            onClick={() => setOpen(!isOpen)}
          >
            <span>+ More items</span>
          </button>
        </div>
      )}
      {isOpen && (
        <>
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-medium">Add more items to return</h3>
          </div>
          <p className="text-sm text-muted-foreground mb-4">
            Select items from the original order to add to this return.
          </p>
          <div className="space-y-4">
            {selectedItems.map((item, i) => {
              return (
                <div
                  key={item.shop_line_item_id}
                  className="flex items-start gap-4 p-4 border rounded-md"
                >
                  <input
                    className="cursor-pointer h-6 w-6 rounded mr-2"
                    id="customAddress"
                    name="customAddress"
                    type="checkbox"
                    onChange={() => updateItem(i, { selected: !item.selected })}
                    checked={item.selected}
                    disabled={item.added}
                  />
                  <div className="flex-shrink-0">
                    <img
                      alt={item.name}
                      className="w-16 h-20 object-cover border rounded"
                      src={item.image_url}
                    />
                  </div>
                  <div className="flex-grow">
                    <div className="font-medium">{item.name}</div>
                    { item.sku && (
                      <div className="text-sm text-muted-foreground">
                        SKU: {item.sku}
                      </div>
                    )}
                    <div className="flex flex-col sm:flex-row sm:items-baseline justify-between gap-2 mt-2">
                      <div className="font-medium">
                        {" "}
                        <Typography
                          element="p"
                          weight="medium"
                          size="lg"
                          height="4"
                          color="gray-825"
                        >
                          {new Intl.NumberFormat("en", {
                            style: "currency",
                            currency: item.currency,
                          }).format(item.amount)}
                        </Typography>
                      </div>
                      <div className="flex flex-col sm:flex-row gap-2 justify-end flex-grow flex-wrap">
                        <div className="flex gap-2 items-baseline">
                          {item.quantity > 1 && (
                            <>
                              <Select
                                className="w-40 bg-white box-border rounded-lg border focus:outline-none py-px px-px font-medium text-sm leading-5 text-gray-875 focus:border-blue-675 focus:border capitalize"
                                onChange={(addedQuantity) =>
                                  updateItem(i, { addedQuantity })
                                }
                                options={quantityOptions(item.quantity)}
                                value={item.addedQuantity}
                                placeholder="Quantity"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <button
            className="bg-white border-blue-675 mt-5 border rounded-lg font-semibold text-xs14 leading-5 text-blue-675 px-4 py-2 focus:outline-none hover:bg-black-625 hover:text-white focus:shadow-btn_blue"
            name="cancel"
            onClick={cancelAddingMoreItems}
          >
            {"Cancel"}
          </button>
          <button
            className="ml-2 bg-white border-blue-675 mt-5 border rounded-lg font-semibold text-xs14 leading-5 text-blue-675 px-4 py-2 focus:outline-none hover:bg-blue-625 hover:text-white focus:shadow-btn_blue"
            name="add_selected_items"
            onClick={handleSubmit}
          >
            {"Add selected items"}
          </button>
        </>
      )}
    </>
  );
};
